export default __webpack_public_path__ + "static/media/janice_kee.a5da03e5.png";